type LogType = 'log' | 'warn' | 'error';

interface ILogger {
  (type: LogType, ...args: any[]): Promise<void>;
  log(...args: any[]): Promise<void>;
  warn(...args: any[]): Promise<void>;
  error(...args: any[]): Promise<void>;
}

export const logger: ILogger = async (
  type,
  ...args
) => {
  const urlParams = new URLSearchParams(window.location.search);
  const debug = (urlParams.get("debug") === "true" || window.location.host.includes("localhost") || window.location.host.includes("dev"));
  const prefix = `[KLEEP] [Sizing iFrame]`;

  if (debug) {
    if (type === 'log') console.log(prefix, ...args);
    else if (type === 'warn') console.warn(prefix, ...args);
    else if (type === 'error') console.error(prefix, ...args);
  }
};

logger.log   = async (...args) => logger('log',   ...args);
logger.warn  = async (...args) => logger('warn',  ...args);
logger.error = async (...args) => logger('error', ...args);
